import { isValid } from "date-fns";
import { sendErrorReport } from "utils/reporting";

export function parseDate(dateStr: string | undefined | null, ignoreTimeZone: boolean = true) {
  const isoWithTZ = /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3})([+-]\d{2}:\d{2})$/; //barcode_leads
  const isoWithMillisecondsTZ = /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2})([+-]\d{2}:\d{2})$/; // new flights/selector
  const isoWithZ = /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2})Z$/; // old flights/selector
  const isoWithMillisecondsWithZ = /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{1,6})Z$/;

  try {
    if (!dateStr) {
      return;
    }

    if (!ignoreTimeZone) {
      return new Date(dateStr);
    }

    // Match ISO format with milliseconds and timezone
    if (isoWithMillisecondsTZ.test(dateStr)) {
      const match = dateStr.match(isoWithMillisecondsTZ);
      if (match) return new Date(match[1]);
    }
    // Match ISO format with timezone
    else if (isoWithTZ.test(dateStr)) {
      const match = dateStr.match(isoWithTZ);
      if (match) return new Date(match[1]);
    }
    // Match ISO format with 'Z' (UTC time)
    else if (isoWithZ.test(dateStr)) {
      const match = dateStr.match(isoWithZ);
      if (match) return new Date(match[1]);
    }
    // Match ISO format with milliseconds and 'Z' (UTC time)
    else if (isoWithMillisecondsWithZ.test(dateStr)) {
      const match = dateStr.match(isoWithMillisecondsWithZ);
      if (match) return new Date(match[1]);
    }
    // Fallback to default date parsing
    else {
      const parsedDate = new Date(dateStr);
      if (!isValid(parsedDate)) {
        sendErrorReport(`Error parsing date - unrecognized format: ${dateStr}`);
        return;
      }
      return parsedDate;
    }
  } catch (error) {
    sendErrorReport(error, `Error parsing date - unrecognized format: ${dateStr}`);
    return;
  }
}
